import React from 'react';
import ProductCard from './ProductCard';
import './Products.css';

const products = [

  {
    id: '1',
    name: 'पनौती आलु',
    description: 'पनौती क्षेत्रको प्रसिद्ध स्वादिलो आलु',
    price: 65,
    image: '🥔',
    category: 'आलु',
    weight: 'प्रति किलो'
  },
  {
    id: '2',
    name: 'मुडे आलु',
    description: 'पहाडी क्षेत्रको गोलो र ठोस आलु',
    price: 60,
    image: '🥔',
    category: 'आलु',
    weight: 'प्रति किलो'
  },
  {
    id: '3',
    name: 'इन्डियन आलु',
    description: 'भारतबाट आयातित ठूलो आकारको आलु',
    price: 55,
    image: '🥔',
    category: 'आलु',
    weight: 'प्रति किलो'
  },
  {
    id: '4',
    name: 'पालुङ आलु',
    description: 'स्वादमा मीठो र आकारमा सानो आलु',
    price: 70,
    image: '🥔',
    category: 'आलु',
    weight: 'प्रति किलो'
  },
  {
    id: '5',
    name: 'त्रिशूली आलु',
    description: 'त्रिशूली क्षेत्रको उत्कृष्ट गुणस्तरको आलु',
    price: 75,
    image: '🥔',
    category: 'आलु',
    weight: 'प्रति किलो'
  },
  {
    id: '6',
    name: 'साँखु आलु',
    description: 'साँखु क्षेत्रको प्रसिद्ध लामो आलु',
    price: 68,
    image: '🥔',
    category: 'आलु',
    weight: 'प्रति किलो'
  },
  {
    id: '7',
    name: 'मसिनो आलु',
    description: 'सानो आकारको चिप्स बनाउन उत्तम',
    price: 62,
    image: '🥔',
    category: 'आलु',
    weight: 'प्रति किलो'
  },
  {
    id: '8',
    name: 'रातो आलु',
    description: 'रातो छालाको मीठो स्वादको आलु',
    price: 72,
    image: '🥔',
    category: 'आलु',
    weight: 'प्रति किलो'
  },


  {
    id: '9',
    name: 'नेपाली प्याज',
    description: 'लालपुर क्षेत्रको तीखो स्वादको प्याज',
    price: 45,
    image: '🧅',
    category: 'प्याज',
    weight: 'प्रति किलो'
  },
  {
    id: '10',
    name: 'भारतीय प्याज',
    description: 'आयातित रसदार र लामो शेल्फ लाइफ',
    price: 40,
    image: '🧅',
    category: 'प्याज',
    weight: 'प्रति किलो'
  },
  {
    id: '11',
    name: 'हरियो प्याज',
    description: 'सलादको लागि उत्तम ताजा हरियो प्याज',
    price: 50,
    image: '🧅',
    category: 'प्याज',
    weight: 'प्रति किलो'
  },




  {
    id: '14',
    name: 'नेपाली लसुन',
    description: 'घरेलु लसुन, तीखो स्वाद र सुगन्ध',
    price: 140,
    image: '🧄',
    category: 'लसुन',
    weight: 'प्रति किलो'
  },
  {
    id: '15',
    name: 'चिनियाँ लसुन',
    description: 'ठूला कलिलाको लसुन, सजिलै भुत्न सकिने',
    price: 120,
    image: '🧄',
    category: 'लसुन',
    weight: 'प्रति किलो'
  },



  {
    id: '18',
    name: 'नयाँ अदुवा',
    description: 'ताजा र कोमल अदुवा, रसदार र सुगन्धित',
    price: 170,
    image: '🫚',
    category: 'अदुवा',
    weight: 'प्रति किलो'
  },
  {
    id: '19',
    name: 'पुरानो अदुवा',
    description: 'सुकेको अदुवा, तीखो स्वाद र लामो शेल्फ लाइफ',
    price: 130,
    image: '🫚',
    category: 'अदुवा',
    weight: 'प्रति किलो'
  }
];

const Products = () => {
  const [activeCategory, setActiveCategory] = React.useState('सबै');

  const categories = ['सबै', 'आलु', 'प्याज', 'लसुन', 'अदुवा'];

  const filteredProducts = activeCategory === 'सबै'
    ? products
    : products.filter(product => product.category === activeCategory);

  return (
    <section className="products-section" id="products">
      <div className="container">
        <h2 className="section-title">उपलब्ध सामग्रीहरू</h2>
        <p className="section-subtitle">विभिन्न प्रकारका ताजा आलु, प्याज, लसुन र अदुवाको संग्रह</p>

        {/* Category Filter */}
        <div className="category-filter">
          {categories.map(category => (
            <button
              key={category}
              className={`filter-btn ${activeCategory === category ? 'active' : ''}`}
              onClick={() => setActiveCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Category Info */}
        <div className="category-info">
          <h3>
            {activeCategory === 'सबै' ? 'सबै उत्पादनहरू' :
              `${activeCategory} को उत्पादनहरू`}
            <span className="product-count"> ({filteredProducts.length})</span>
          </h3>
          <p className="category-description">
            {activeCategory === 'आलु' && 'विभिन्न किसिमका स्वादिलो आलुहरू'}
            {activeCategory === 'प्याज' && 'ताजा र तीखो स्वादको प्याज'}
            {activeCategory === 'लसुन' && 'सुगन्धित र औषधीय गुण भएको लसुन'}
            {activeCategory === 'अदुवा' && 'ताजा र रोगनिरोधी गुण भएको अदुवा'}
            {activeCategory === 'सबै' && 'सबै प्रकारका ताजा सब्जीहरू'}
          </p>
        </div>

        {/* Products Grid */}
        <div className="products-grid">
          {filteredProducts.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>

        {/* No Products Message */}
        {filteredProducts.length === 0 && (
          <div className="no-products">
            <div className="no-products-icon">😔</div>
            <h3>उत्पादन भेटिएन</h3>
            <p>यो श्रेणीमा कुनै उत्पादन उपलब्ध छैन। कृपया अर्को श्रेणी छनौट गर्नुहोस्।</p>
          </div>
        )}

        {/* Products Note */}
        <div className="products-note">
          <div className="note-icon">💡</div>
          <div className="note-content">
            <h4>उत्पादनको बारेमा जानकारी:</h4>
            <p>सबै उत्पादन ताजा र गुणस्तरीय छन्। थोक खरिदको लागि सम्पर्क गर्नुहोस्।</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;